export default {
  en: {
    title: 'Premium',
    close: 'Close',
    plansLabel: 'Plan',
    plans: { year: 'Yearly', quarter: '3 months', month: 'Monthly' },
    perMonth: '{{price}} / month',
    totalAndMonthly: '{{total}} · {{monthly}} / month',
    bestValue: 'Best value',
    includedTitle: 'What’s included',
    perks: {
      voice: 'Voice conversations',
      mistakes: 'Mistake breakdowns',
      topics: 'Hundreds of topics and role-plays',
      words: 'Word lists with review',
      level: 'Level check',
      stats: 'Full statistics',
      personalization: 'Personalization',
      reminders: 'Reminders',
      history: 'Conversation history',
    },
    perkTexts: {
      voice: 'Speak out loud as much as you like — the tutor never tires or rushes you',
      mistakes: 'Every mistake explained: what went wrong and how to say it right',
      topics: 'No need to think up what to talk about — pick a topic or a scene and start',
      personalization: 'The tutor remembers your interests, goals and level and tailors every conversation to you',
      words: 'Words from your lists come back in conversations until they stick',
      level: 'A monthly voice check shows how much you’ve grown',
      stats: 'Practice time, streak and skill progress — all on one screen',
      reminders: 'The bot reminds you to practice so you don’t lose your rhythm',
      history: 'Every conversation is saved — come back and reread it anytime',
    },
    plansTitle: 'Choose a plan',
    seePlans: 'See plans',
    demoTitle: 'What you get',
    trust: {
      secure: 'Secure payment — your card details never reach us',
      instant: 'Access opens right after payment',
      cancel: 'Auto-renewal can be turned off anytime',
    },
    reviewsTitle: 'What learners say',
    starsLabel: '{{count}} out of 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Marina',
        title: 'No more fear of mistakes',
        text: 'At my speaking club I mostly stayed quiet — I was embarrassed to say something wrong. Here nobody watches or judges, so I just talk. The more I talk, the easier it gets, and mistakes are explained after I answer.',
      },
      noFreeze: {
        author: 'Dmitry',
        title: 'The freeze is gone',
        text: 'I understood everything, but the moment I had to answer — pause and panic. A couple of weeks of speaking out loud for 15 minutes a day, and sentences started coming on their own, without translating in my head.',
      },
      price: {
        author: 'Anna',
        title: 'Cheaper than one lesson',
        text: 'I could only afford a tutor once a week — and that’s not enough to start speaking. Here a whole month costs less than one lesson, and I practice every day.',
      },
      time: {
        author: 'Igor',
        title: 'I practice when it suits me',
        text: 'My schedule is all over the place, I kept missing tutor sessions. Now I start a conversation at lunch or on the way home: ten minutes and that’s practice done.',
      },
      words: {
        author: 'Ksenia',
        title: 'My words finally made it into speech',
        text: 'I knew lots of words but couldn’t recall them mid-conversation. Words from my lists come up right in the dialogues — hear one a couple of times, answer, and now I use it myself.',
      },
      progress: {
        author: 'Alexey',
        title: 'I can finally see progress',
        text: 'I’d been learning English since school and going nowhere. Here the level check shows what I’ve improved: fluency and grammar have clearly grown. That keeps me going better than any motivation.',
      },
    },
    cta: 'Pay {{price}}',
    ctaNoPrice: 'Get Full Access',
    creating: 'Creating payment…',
    goToPayment: 'Go to payment',
    checking: 'Checking payment…',
    checkPayment: 'I’ve paid — check',
    pendingTitle: 'Awaiting payment',
    pendingCancel: 'Cancel',
    waitingHint: 'The payment page is open. Once you pay, come back here — access opens by itself.',
    checkoutError: 'Couldn’t open the payment. Please try again.',
    autoRenewTitle: 'Auto-renewal',
    autoRenewText: 'We’ll remind you 3 days before the charge',
    consentTitle: 'Personal data processing',
    consentText: 'I consent to the processing of my data',
    offerTitle: 'Public offer',
    offerText: 'I accept the terms of use and payment',
    every: { year: 'every year', quarter: 'every 3 months', month: 'every month' },
    emailLabel: 'Email for the receipt',
    emailPlaceholder: 'Email for the receipt',
    docs: { offer: 'Terms of Service', privacy: 'Privacy Policy', consent: 'Consent to personal data processing' },
  },
  ru: {
    title: 'Премиум',
    close: 'Закрыть',
    plansLabel: 'Тариф',
    plans: { year: 'На год', quarter: 'На 3 месяца', month: 'На месяц' },
    perMonth: '{{price}} / мес',
    totalAndMonthly: '{{total}} · {{monthly}} / мес',
    bestValue: 'Выгоднее',
    includedTitle: 'Что входит',
    perks: {
      voice: 'Голосовые диалоги',
      mistakes: 'Разбор ошибок',
      topics: 'Сотни тем и ролевых игр',
      words: 'Словари с повторением',
      level: 'Проверка уровня',
      stats: 'Полная статистика',
      personalization: 'Персонализация',
      reminders: 'Напоминания',
      history: 'История разговоров',
    },
    perkTexts: {
      voice: 'Говори вслух сколько хочешь — репетитор не устаёт и не торопит',
      mistakes: 'Каждая ошибка разобрана: что не так и как сказать правильно',
      topics: 'Не нужно придумывать, о чём говорить, — выбери тему или сцену и начинай',
      personalization: 'Репетитор помнит твои интересы, цели и уровень и подстраивает разговор под тебя',
      words: 'Слова из словаря возвращаются в диалогах, пока не запомнятся',
      level: 'Раз в месяц голосовая проверка показывает, насколько ты вырос',
      stats: 'Время практики, стрик и прогресс по навыкам — на одном экране',
      reminders: 'Бот напомнит позаниматься, чтобы не выпасть из ритма',
      history: 'Все разговоры сохраняются — можно вернуться и перечитать',
    },
    plansTitle: 'Выбор тарифа',
    seePlans: 'Посмотреть тарифы',
    demoTitle: 'Что ты получишь',
    trust: {
      secure: 'Безопасная оплата — данные карты к нам не попадают',
      instant: 'Доступ откроется сразу после оплаты',
      cancel: 'Автопродление можно отключить в любой момент',
    },
    reviewsTitle: 'Что говорят пользователи',
    starsLabel: '{{count}} из 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Марина',
        title: 'Перестала бояться ошибок',
        text: 'В разговорном клубе я больше молчала — было стыдно сказать неправильно. Здесь никто не смотрит и не оценивает, поэтому я просто говорю. Чем больше говорю, тем свободнее получается, а ошибки разбираются после ответа.',
      },
      noFreeze: {
        author: 'Дмитрий',
        title: 'Ушёл ступор',
        text: 'Всё понимал, но как только нужно было ответить — пауза и паника. Пару недель говорил вслух минут по 15 в день, и фразы начали складываться сами, без перевода в голове.',
      },
      price: {
        author: 'Анна',
        title: 'Дешевле одного урока',
        text: 'Занятия с репетитором были мне по карману только раз в неделю — а этого мало, чтобы заговорить. Здесь месяц стоит меньше одного урока, а практикуюсь каждый день.',
      },
      time: {
        author: 'Игорь',
        title: 'Занимаюсь, когда удобно',
        text: 'График рваный, к репетитору постоянно не успевал. Теперь включаю разговор в обед или по дороге домой: десять минут — и уже практика.',
      },
      words: {
        author: 'Ксения',
        title: 'Слова наконец пошли в речь',
        text: 'Знала кучу слов, но в разговоре не могла их вспомнить. Слова из словаря попадаются прямо в диалогах — пару раз услышала, ответила, и уже пользуюсь ими сама.',
      },
      progress: {
        author: 'Алексей',
        title: 'Наконец вижу прогресс',
        text: 'Учил английский со школы и топтался на месте. Здесь проверка уровня показывает, что подтянул: беглость и грамматика заметно выросли. Это держит лучше любой мотивации.',
      },
    },
    cta: 'Оплатить {{price}}',
    ctaNoPrice: 'Получить полный доступ',
    creating: 'Создаём платёж…',
    goToPayment: 'Перейти к оплате',
    checking: 'Проверяем оплату…',
    checkPayment: 'Я оплатил — проверить',
    pendingTitle: 'Ждёт оплаты',
    pendingCancel: 'Отменить',
    waitingHint: 'Страница оплаты открыта. Оплатишь — возвращайся сюда, доступ откроется сам.',
    checkoutError: 'Не получилось открыть оплату. Попробуй ещё раз.',
    autoRenewTitle: 'Автопродление',
    autoRenewText: 'Напомним за 3 дня до списания',
    consentTitle: 'Обработка персональных данных',
    consentText: 'Даю согласие на обработку моих данных',
    offerTitle: 'Публичная оферта',
    offerText: 'Принимаю условия пользования и оплаты',
    every: { year: 'раз в год', quarter: 'раз в 3 месяца', month: 'раз в месяц' },
    emailLabel: 'Почта для чека',
    emailPlaceholder: 'Почта для чека',
    docs: { offer: 'Оферта', privacy: 'Политика конфиденциальности', consent: 'Согласие на обработку персональных данных' },
  },
  de: {
    title: 'Premium',
    close: 'Schließen',
    plansLabel: 'Tarif',
    plans: { year: 'Jährlich', quarter: '3 Monate', month: 'Monatlich' },
    perMonth: '{{price}} / Monat',
    totalAndMonthly: '{{total}} · {{monthly}} / Monat',
    bestValue: 'Bester Wert',
    includedTitle: 'Was enthalten ist',
    perks: {
      voice: 'Sprachdialoge',
      mistakes: 'Fehleranalyse',
      topics: 'Hunderte Themen und Rollenspiele',
      words: 'Wortlisten mit Wiederholung',
      level: 'Einstufungstest',
      stats: 'Volle Statistik',
      personalization: 'Personalisierung',
      reminders: 'Erinnerungen',
      history: 'Gesprächsverlauf',
    },
    perkTexts: {
      voice: 'Sprich laut, so viel du willst — der Tutor wird nie müde und drängt nicht',
      mistakes: 'Jeder Fehler erklärt: was falsch war und wie es richtig heißt',
      topics: 'Du musst dir kein Gesprächsthema ausdenken — wähl ein Thema oder eine Szene und leg los',
      personalization: 'Der Tutor kennt deine Interessen, Ziele und dein Niveau und passt jedes Gespräch an dich an',
      words: 'Wörter aus deinen Listen kommen in Gesprächen wieder, bis sie sitzen',
      level: 'Ein monatlicher Sprechtest zeigt, wie weit du gekommen bist',
      stats: 'Übungszeit, Serie und Fortschritt pro Fähigkeit — alles auf einem Bildschirm',
      reminders: 'Der Bot erinnert dich ans Üben, damit du im Rhythmus bleibst',
      history: 'Alle Gespräche werden gespeichert — jederzeit nachlesen',
    },
    plansTitle: 'Tarifwahl',
    seePlans: 'Tarife ansehen',
    demoTitle: 'Was du bekommst',
    trust: {
      secure: 'Sichere Zahlung — deine Kartendaten erreichen uns nie',
      instant: 'Der Zugang wird sofort nach der Zahlung freigeschaltet',
      cancel: 'Die automatische Verlängerung ist jederzeit abschaltbar',
    },
    reviewsTitle: 'Was Lernende sagen',
    starsLabel: '{{count}} von 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Marina',
        title: 'Keine Angst mehr vor Fehlern',
        text: 'Im Sprechclub habe ich meist geschwiegen — es war mir peinlich, etwas Falsches zu sagen. Hier schaut niemand zu und bewertet nicht, also spreche ich einfach. Je mehr ich rede, desto leichter wird es, und Fehler werden nach der Antwort erklärt.',
      },
      noFreeze: {
        author: 'Dmitri',
        title: 'Die Blockade ist weg',
        text: 'Ich habe alles verstanden, aber sobald ich antworten musste — Pause und Panik. Ein paar Wochen jeden Tag 15 Minuten laut sprechen, und die Sätze kamen von selbst, ohne im Kopf zu übersetzen.',
      },
      price: {
        author: 'Anna',
        title: 'Günstiger als eine Stunde',
        text: 'Einen Tutor konnte ich mir nur einmal pro Woche leisten — zu wenig, um ins Sprechen zu kommen. Hier kostet ein ganzer Monat weniger als eine Stunde, und ich übe jeden Tag.',
      },
      time: {
        author: 'Igor',
        title: 'Ich übe, wann es passt',
        text: 'Mein Kalender ist chaotisch, Termine beim Tutor habe ich ständig verpasst. Jetzt starte ich ein Gespräch in der Mittagspause oder auf dem Heimweg: zehn Minuten, und schon geübt.',
      },
      words: {
        author: 'Xenia',
        title: 'Die Wörter landen endlich im Sprechen',
        text: 'Ich kannte viele Wörter, konnte sie im Gespräch aber nicht abrufen. Wörter aus meinen Listen tauchen direkt in den Dialogen auf — ein paarmal gehört, geantwortet, und jetzt benutze ich sie selbst.',
      },
      progress: {
        author: 'Alexej',
        title: 'Endlich sehe ich Fortschritt',
        text: 'Ich habe seit der Schule Englisch gelernt und bin nicht vorangekommen. Hier zeigt der Einstufungstest, was besser geworden ist: Flüssigkeit und Grammatik sind deutlich gewachsen. Das motiviert mehr als alles andere.',
      },
    },
    cta: '{{price}} bezahlen',
    ctaNoPrice: 'Vollen Zugang holen',
    creating: 'Zahlung wird erstellt…',
    goToPayment: 'Zur Zahlung',
    checking: 'Zahlung wird geprüft…',
    checkPayment: 'Ich habe bezahlt — prüfen',
    pendingTitle: 'Wartet auf Zahlung',
    pendingCancel: 'Abbrechen',
    waitingHint: 'Die Zahlungsseite ist offen. Komm nach dem Bezahlen hierher zurück — der Zugang wird automatisch freigeschaltet.',
    checkoutError: 'Die Zahlung konnte nicht geöffnet werden. Bitte versuche es erneut.',
    autoRenewTitle: 'Automatische Verlängerung',
    autoRenewText: 'Wir erinnern dich 3 Tage vor der Abbuchung',
    consentTitle: 'Verarbeitung personenbezogener Daten',
    consentText: 'Ich willige in die Verarbeitung meiner Daten ein',
    offerTitle: 'Öffentliches Angebot',
    offerText: 'Ich akzeptiere die Nutzungs- und Zahlungsbedingungen',
    every: { year: 'jährlich', quarter: 'alle 3 Monate', month: 'monatlich' },
    emailLabel: 'E-Mail für den Beleg',
    emailPlaceholder: 'E-Mail für den Beleg',
    docs: { offer: 'Nutzungsbedingungen', privacy: 'Datenschutz', consent: 'Einwilligung zur Datenverarbeitung' },
  },
  pt: {
    title: 'Premium',
    close: 'Fechar',
    plansLabel: 'Plano',
    plans: { year: 'Anual', quarter: '3 meses', month: 'Mensal' },
    perMonth: '{{price}} / mês',
    totalAndMonthly: '{{total}} · {{monthly}} / mês',
    bestValue: 'Melhor valor',
    includedTitle: 'O que está incluído',
    perks: {
      voice: 'Diálogos por voz',
      mistakes: 'Análise de erros',
      topics: 'Centenas de temas e role-plays',
      words: 'Listas com revisão',
      level: 'Teste de nível',
      stats: 'Estatísticas completas',
      personalization: 'Personalização',
      reminders: 'Lembretes',
      history: 'Histórico de conversas',
    },
    perkTexts: {
      voice: 'Fale em voz alta o quanto quiser — o tutor não cansa nem apressa',
      mistakes: 'Cada erro explicado: o que deu errado e como dizer certo',
      topics: 'Sem precisar inventar assunto — escolha um tema ou uma cena e comece',
      personalization: 'O tutor lembra seus interesses, objetivos e nível e adapta cada conversa a você',
      words: 'Palavras das suas listas voltam nas conversas até ficarem',
      level: 'Um teste de voz mensal mostra o quanto você evoluiu',
      stats: 'Tempo de prática, sequência e progresso por habilidade — tudo numa tela',
      reminders: 'O bot lembra você de praticar para não perder o ritmo',
      history: 'Todas as conversas ficam salvas — volte e releia quando quiser',
    },
    plansTitle: 'Escolha do plano',
    seePlans: 'Ver planos',
    demoTitle: 'O que você ganha',
    trust: {
      secure: 'Pagamento seguro — os dados do cartão não chegam até nós',
      instant: 'O acesso abre logo após o pagamento',
      cancel: 'A renovação automática pode ser desativada a qualquer momento',
    },
    reviewsTitle: 'O que dizem os alunos',
    starsLabel: '{{count}} de 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Marina',
        title: 'Perdi o medo de errar',
        text: 'No clube de conversação eu quase não falava — tinha vergonha de dizer algo errado. Aqui ninguém observa nem julga, então eu simplesmente falo. Quanto mais falo, mais fácil fica, e os erros são explicados depois da resposta.',
      },
      noFreeze: {
        author: 'Dmitri',
        title: 'O bloqueio sumiu',
        text: 'Eu entendia tudo, mas na hora de responder — pausa e pânico. Algumas semanas falando em voz alta 15 minutos por dia, e as frases começaram a sair sozinhas, sem traduzir na cabeça.',
      },
      price: {
        author: 'Anna',
        title: 'Mais barato que uma aula',
        text: 'Eu só conseguia pagar aula com professor uma vez por semana — e isso não basta para começar a falar. Aqui um mês inteiro custa menos que uma aula, e eu pratico todo dia.',
      },
      time: {
        author: 'Igor',
        title: 'Pratico quando dá',
        text: 'Minha agenda é uma bagunça, eu sempre perdia as aulas. Agora começo uma conversa no almoço ou voltando para casa: dez minutos e já pratiquei.',
      },
      words: {
        author: 'Ksenia',
        title: 'As palavras finalmente viraram fala',
        text: 'Eu sabia muitas palavras, mas não lembrava delas na conversa. As palavras das minhas listas aparecem nos diálogos — ouvi algumas vezes, respondi, e agora uso sozinha.',
      },
      progress: {
        author: 'Alexei',
        title: 'Finalmente vejo progresso',
        text: 'Estudava inglês desde a escola e não saía do lugar. Aqui o teste de nível mostra o que melhorou: fluência e gramática cresceram de verdade. Isso me mantém melhor que qualquer motivação.',
      },
    },
    cta: 'Pagar {{price}}',
    ctaNoPrice: 'Obter acesso total',
    creating: 'Criando pagamento…',
    goToPayment: 'Ir para o pagamento',
    checking: 'Verificando pagamento…',
    checkPayment: 'Já paguei — verificar',
    pendingTitle: 'Aguardando pagamento',
    pendingCancel: 'Cancelar',
    waitingHint: 'A página de pagamento está aberta. Depois de pagar, volte aqui — o acesso abre sozinho.',
    checkoutError: 'Não foi possível abrir o pagamento. Tente novamente.',
    autoRenewTitle: 'Renovação automática',
    autoRenewText: 'Avisamos 3 dias antes da cobrança',
    consentTitle: 'Tratamento de dados pessoais',
    consentText: 'Autorizo o tratamento dos meus dados',
    offerTitle: 'Oferta pública',
    offerText: 'Aceito os termos de uso e pagamento',
    every: { year: 'por ano', quarter: 'a cada 3 meses', month: 'por mês' },
    emailLabel: 'E-mail para o recibo',
    emailPlaceholder: 'E-mail para o recibo',
    docs: { offer: 'Termos de uso', privacy: 'Política de privacidade', consent: 'Consentimento de dados pessoais' },
  },
  fr: {
    title: 'Premium',
    close: 'Fermer',
    plansLabel: 'Formule',
    plans: { year: 'Annuel', quarter: '3 mois', month: 'Mensuel' },
    perMonth: '{{price}} / mois',
    totalAndMonthly: '{{total}} · {{monthly}} / mois',
    bestValue: 'Meilleure offre',
    includedTitle: 'Ce qui est inclus',
    perks: {
      voice: 'Dialogues à l’oral',
      mistakes: 'Analyse des erreurs',
      topics: 'Des centaines de sujets et de jeux de rôle',
      words: 'Listes avec révision',
      level: 'Test de niveau',
      stats: 'Statistiques complètes',
      personalization: 'Personnalisation',
      reminders: 'Rappels',
      history: 'Historique des conversations',
    },
    perkTexts: {
      voice: 'Parle à voix haute autant que tu veux — le tuteur ne se lasse pas et ne te presse pas',
      mistakes: 'Chaque erreur expliquée : ce qui cloche et comment bien le dire',
      topics: 'Pas besoin de chercher quoi dire — choisis un sujet ou une scène et lance-toi',
      personalization: 'Le tuteur retient tes intérêts, tes objectifs et ton niveau et adapte chaque conversation',
      words: 'Les mots de tes listes reviennent dans les conversations jusqu’à ce qu’ils restent',
      level: 'Un test oral chaque mois montre tes progrès',
      stats: 'Temps de pratique, série et progrès par compétence — sur un seul écran',
      reminders: 'Le bot te rappelle de pratiquer pour garder le rythme',
      history: 'Toutes les conversations sont enregistrées — relis-les quand tu veux',
    },
    plansTitle: 'Choix de la formule',
    seePlans: 'Voir les formules',
    demoTitle: 'Ce que tu obtiens',
    trust: {
      secure: 'Paiement sécurisé — tes données de carte ne nous parviennent jamais',
      instant: 'L’accès s’ouvre dès le paiement',
      cancel: 'Le renouvellement automatique se désactive à tout moment',
    },
    reviewsTitle: 'Ce qu’en disent les apprenants',
    starsLabel: '{{count}} sur 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Marina',
        title: 'Plus peur de me tromper',
        text: 'Au club de conversation, je me taisais surtout — j’avais honte de dire une bêtise. Ici, personne ne regarde ni ne juge, alors je parle, tout simplement. Plus je parle, plus c’est facile, et les erreurs sont expliquées après ma réponse.',
      },
      noFreeze: {
        author: 'Dmitri',
        title: 'Le blocage a disparu',
        text: 'Je comprenais tout, mais dès qu’il fallait répondre — pause et panique. Quelques semaines à parler à voix haute 15 minutes par jour, et les phrases sont venues toutes seules, sans traduire dans ma tête.',
      },
      price: {
        author: 'Anna',
        title: 'Moins cher qu’un cours',
        text: 'Je ne pouvais me payer un prof qu’une fois par semaine — et ça ne suffit pas pour se mettre à parler. Ici, un mois entier coûte moins qu’un cours, et je pratique tous les jours.',
      },
      time: {
        author: 'Igor',
        title: 'Je pratique quand ça m’arrange',
        text: 'Mon emploi du temps est chaotique, je ratais sans cesse mes cours. Maintenant je lance une conversation à midi ou en rentrant : dix minutes et c’est de la pratique.',
      },
      words: {
        author: 'Xenia',
        title: 'Mes mots passent enfin à l’oral',
        text: 'Je connaissais plein de mots mais je ne les retrouvais pas en conversation. Les mots de mes listes reviennent dans les dialogues — entendus deux fois, une réponse, et je les utilise moi-même.',
      },
      progress: {
        author: 'Alexeï',
        title: 'Enfin des progrès visibles',
        text: 'J’apprenais l’anglais depuis l’école sans avancer. Ici, le test de niveau montre ce qui s’est amélioré : aisance et grammaire ont nettement progressé. Ça motive plus que tout.',
      },
    },
    cta: 'Payer {{price}}',
    ctaNoPrice: 'Obtenir l’accès complet',
    creating: 'Création du paiement…',
    goToPayment: 'Aller au paiement',
    checking: 'Vérification du paiement…',
    checkPayment: 'J’ai payé — vérifier',
    pendingTitle: 'En attente de paiement',
    pendingCancel: 'Annuler',
    waitingHint: 'La page de paiement est ouverte. Une fois payé, reviens ici — l’accès s’ouvre tout seul.',
    checkoutError: 'Impossible d’ouvrir le paiement. Réessaie.',
    autoRenewTitle: 'Renouvellement automatique',
    autoRenewText: 'On te prévient 3 jours avant le prélèvement',
    consentTitle: 'Traitement des données personnelles',
    consentText: 'J’accepte le traitement de mes données',
    offerTitle: 'Offre publique',
    offerText: 'J’accepte les conditions d’utilisation et de paiement',
    every: { year: 'chaque année', quarter: 'tous les 3 mois', month: 'chaque mois' },
    emailLabel: 'E-mail pour le reçu',
    emailPlaceholder: 'E-mail pour le reçu',
    docs: { offer: 'Conditions d’utilisation', privacy: 'Confidentialité', consent: 'Consentement aux données personnelles' },
  },
  es: {
    title: 'Premium',
    close: 'Cerrar',
    plansLabel: 'Plan',
    plans: { year: 'Anual', quarter: '3 meses', month: 'Mensual' },
    perMonth: '{{price}} / mes',
    totalAndMonthly: '{{total}} · {{monthly}} / mes',
    bestValue: 'Mejor precio',
    includedTitle: 'Qué incluye',
    perks: {
      voice: 'Diálogos por voz',
      mistakes: 'Análisis de errores',
      topics: 'Cientos de temas y juegos de rol',
      words: 'Listas con repaso',
      level: 'Prueba de nivel',
      stats: 'Estadísticas completas',
      personalization: 'Personalización',
      reminders: 'Recordatorios',
      history: 'Historial de conversaciones',
    },
    perkTexts: {
      voice: 'Habla en voz alta cuanto quieras — el tutor no se cansa ni te apura',
      mistakes: 'Cada error explicado: qué falló y cómo decirlo bien',
      topics: 'Sin tener que inventar de qué hablar: elige un tema o una escena y empieza',
      personalization: 'El tutor recuerda tus intereses, metas y nivel y adapta cada conversación a ti',
      words: 'Las palabras de tus listas vuelven en las conversaciones hasta que se quedan',
      level: 'Una prueba oral mensual muestra cuánto has avanzado',
      stats: 'Tiempo de práctica, racha y progreso por habilidad — en una sola pantalla',
      reminders: 'El bot te recuerda practicar para no perder el ritmo',
      history: 'Todas las conversaciones se guardan — vuelve y reléelas cuando quieras',
    },
    plansTitle: 'Elección de plan',
    seePlans: 'Ver planes',
    demoTitle: 'Lo que obtienes',
    trust: {
      secure: 'Pago seguro — los datos de tu tarjeta nunca nos llegan',
      instant: 'El acceso se abre justo después del pago',
      cancel: 'La renovación automática se puede desactivar en cualquier momento',
    },
    reviewsTitle: 'Qué dicen los usuarios',
    starsLabel: '{{count}} de 5',
    // ЗАГЛУШКА: не настоящие отзывы, см. `ReviewsCarousel`.
    reviews: {
      noFear: {
        author: 'Marina',
        title: 'Perdí el miedo a equivocarme',
        text: 'En el club de conversación casi no hablaba — me daba vergüenza decir algo mal. Aquí nadie mira ni juzga, así que simplemente hablo. Cuanto más hablo, más fácil me resulta, y los errores se explican después de cada respuesta.',
      },
      noFreeze: {
        author: 'Dmitri',
        title: 'Se acabó el bloqueo',
        text: 'Lo entendía todo, pero en cuanto tenía que responder — pausa y pánico. Un par de semanas hablando en voz alta 15 minutos al día, y las frases empezaron a salir solas, sin traducir en la cabeza.',
      },
      price: {
        author: 'Anna',
        title: 'Más barato que una clase',
        text: 'Solo podía pagarme un profesor una vez por semana — y eso no basta para empezar a hablar. Aquí un mes entero cuesta menos que una clase, y practico todos los días.',
      },
      time: {
        author: 'Igor',
        title: 'Practico cuando me viene bien',
        text: 'Mi horario es un caos, siempre me perdía las clases. Ahora empiezo una conversación en el almuerzo o de camino a casa: diez minutos y ya es práctica.',
      },
      words: {
        author: 'Ksenia',
        title: 'Las palabras por fin llegan a mi habla',
        text: 'Sabía muchas palabras, pero no las recordaba al conversar. Las palabras de mis listas aparecen en los diálogos — las oigo un par de veces, respondo, y ya las uso yo sola.',
      },
      progress: {
        author: 'Alexéi',
        title: 'Por fin veo progreso',
        text: 'Estudiaba inglés desde el colegio sin avanzar. Aquí la prueba de nivel muestra qué he mejorado: la fluidez y la gramática han crecido de verdad. Eso me mantiene mejor que cualquier motivación.',
      },
    },
    cta: 'Pagar {{price}}',
    ctaNoPrice: 'Obtener acceso completo',
    creating: 'Creando el pago…',
    goToPayment: 'Ir al pago',
    checking: 'Comprobando el pago…',
    checkPayment: 'Ya pagué — comprobar',
    pendingTitle: 'Pendiente de pago',
    pendingCancel: 'Cancelar',
    waitingHint: 'La página de pago está abierta. Cuando pagues, vuelve aquí: el acceso se abre solo.',
    checkoutError: 'No se pudo abrir el pago. Inténtalo de nuevo.',
    autoRenewTitle: 'Renovación automática',
    autoRenewText: 'Te avisamos 3 días antes del cobro',
    consentTitle: 'Tratamiento de datos personales',
    consentText: 'Acepto el tratamiento de mis datos',
    offerTitle: 'Oferta pública',
    offerText: 'Acepto las condiciones de uso y pago',
    every: { year: 'cada año', quarter: 'cada 3 meses', month: 'cada mes' },
    emailLabel: 'Correo para el recibo',
    emailPlaceholder: 'Correo para el recibo',
    docs: { offer: 'Términos de uso', privacy: 'Privacidad', consent: 'Consentimiento de datos personales' },
  },
};
